export const COL_LABEL = "col-12";
export const COL_INPUT = "col-12";

export const LABEL_QUEST = "Frage";
export const LABEL_QUEST_IMG = "Bild/Video zur Frage";
